import { Component, OnInit } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { WarehouseLocation } from '../../shared/models/warehouse.location.interface';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-warehouselocation',
  templateUrl: './warehouselocation.component.html',
  styleUrls: ['./warehouselocation.component.scss']
})
export class WarehouselocationComponent implements OnInit {

  constructor(private adminService: AdminService, private route: ActivatedRoute, private router: Router) { }

  warehouseLocation: WarehouseLocation;
  states: string[];
  errors: string;
  isRequesting: boolean;

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      let warehouseLocationId: string = params.get('warehouseLocationId');
      let warehouseId: string = params.get('warehouseId');

      if (warehouseLocationId == null) {
        this.warehouseLocation = {} as WarehouseLocation;
        this.warehouseLocation.warehouseLocation_IsActive = true;
        this.warehouseLocation.warehouse_ID = +warehouseId;
      }
      else {
        this.adminService.getWarehouseLocation(warehouseLocationId)
          .subscribe({
            next: (data) => {
              this.warehouseLocation = data;
            }
          })
      }

    });

  }

  saveWarehouseLocation(form: NgForm) {
    var proceed = confirm($localize`Are you sure?`);
    if (!proceed) return;

    this.route.paramMap.subscribe(params => {
      console.log('in Warehouse Location onSubmit: ', this.warehouseLocation);
      let warehouseId = params.get('warehouseId');
      this.errors = '';
      if (form.valid) {
        this.isRequesting = true;
        this.adminService.saveWarehouseLocation(warehouseId, this.warehouseLocation)
          .pipe(finalize(() => this.isRequesting = false))
          .subscribe({
            next: (result) => {
              if (result) {
                this.router.navigate(['/admin/warehouse/' + warehouseId]);
              }
            },
            error: (error: string) => this.errors = error
          });
      }
    });
  }

}
